import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import { LANG_OPTIONS, makeT } from "../../lib/staffI18n";

export default function StaffLogin() {
  const [lang, setLang] = useState("ja");
  const [loginId, setLoginId] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const t = makeT(lang);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const r = await api.post("/staff/login", { login_id: loginId, password });
      if (r.data.language) setLang(r.data.language);
      navigate("/staff");
    } catch {
      setError(t("login_failed"));
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full border border-line bg-ink px-4 py-4 text-base text-white outline-none transition-colors focus:border-accent";

  return (
    <div data-testid="staff-login-page" className="flex min-h-screen flex-col items-center justify-center bg-ink px-4">
      <div className="w-full max-w-sm">
        <div className="flex items-center justify-center gap-3">
          <img src="/neo-logo.png" alt="NEO CONSTRUCTION" className="h-10 w-auto rounded-md" />
        </div>
        <h1 className="mt-6 text-center font-mincho text-xl font-bold text-white">{t("login_title")}</h1>

        <div className="mt-4 flex justify-center">
          <select data-testid="staff-login-language" value={lang} onChange={(e) => setLang(e.target.value)} className="border border-line bg-coal px-3 py-2 text-sm text-gray-300 outline-none focus:border-accent">
            {LANG_OPTIONS.map((l) => (
              <option key={l.code} value={l.code}>{l.label}</option>
            ))}
          </select>
        </div>

        <form onSubmit={submit} className="mt-8 space-y-4">
          <input data-testid="staff-login-id" value={loginId} onChange={(e) => setLoginId(e.target.value)} placeholder={t("login_id")} autoComplete="username" className={inputCls} />
          <input data-testid="staff-login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder={t("password")} autoComplete="current-password" className={inputCls} />
          {error && <p data-testid="staff-login-error" className="text-sm text-red-400">{error}</p>}
          <button data-testid="staff-login-submit" type="submit" disabled={loading || !loginId || !password} className="w-full bg-accent py-4 text-base font-bold text-ink transition-colors hover:bg-accent-hover disabled:opacity-40">
            {loading ? "..." : t("sign_in")}
          </button>
        </form>
      </div>
    </div>
  );
}
